jQuery(document).ready(function ($) {

	function closeSeparatePopup() {
		const $teaser = $('.whitepaper-separate-popup');
		$teaser.fadeOut(300, function () {
			$(this).removeClass('is-visible');
			$('body').css('overflow', '');
		});
		sessionStorage.setItem('whitepaper_separate_dismissed', 'true');
	}

	$(document).on('click', '#js-close-separate-popup', function (e) {
		e.preventDefault();
		closeSeparatePopup();
	});

	$(document).on('click', '.whitepaper-separate-popup .popup-button', function (e) {
		if ($(this).is('a')) {
			closeSeparatePopup();
		}
	});

	$(document).on('click', '.js-open-whitepaper-form', function (e) {
		e.preventDefault();
		$('#whitepaper-form-wrapper').css('display', 'flex').hide().fadeIn(300);
		$('body').css('overflow', 'hidden');
		$(document).trigger('gform_post_render');
	});

	$(document).on('click', '#whitepaper-form-wrapper', function (e) {
		if (e.target === e.currentTarget) {
			closeFullForm($(this));
		}
	});

	$(document).on('click', '.form__btn--close', function (e) {
		e.preventDefault();
		const $wrapper = $(this).closest('.whitepaper-form-wrapper');
		if ($wrapper.length) {
			closeFullForm($wrapper);
		}
	});

	function closeFullForm($wrapper) {
		const isDesktop = window.innerWidth >= 769;
		if (isDesktop) {
			$wrapper.fadeOut(300, function() {
				$('body').css('overflow', '');
			});
		} else {
			$wrapper.hide();
			$('body').css('overflow', '');
		}
	}

	$(document).on('click', '.js-popup-whitepaper', function (e) {
		e.stopPropagation();
	});

	$(window).on('resize', function () {
		const wrapper = $('#whitepaper-form-wrapper');
		if (window.innerWidth < 769 && wrapper.is(':visible')) {
			$('body').css('overflow', '');
		}
	});

	$(document).on('gform_confirmation_loaded', function (event, formId) {
		const $wrapper = $('#whitepaper-form-wrapper');
		const $teaser = $('.whitepaper-separate-popup');
		const popupId = $teaser.attr('data-whitepaper-popup');

		$wrapper.find('.whitepaper-form-title').hide();

		if (popupId) {
			let submittedPopups = JSON.parse(localStorage.getItem('whitepaper_submitted_ids')) || [];
			if (!submittedPopups.includes(popupId)) {
				submittedPopups.push(popupId);
				localStorage.setItem('whitepaper_submitted_ids', JSON.stringify(submittedPopups));
			}

			$teaser.fadeOut(300).removeClass('is-visible');
		}
	});

	const submittedPopups = JSON.parse(localStorage.getItem('whitepaper_submitted_ids')) || [];

	$.ajax({
		url: window.options.ajax_url,
		data: {
			action: 'get_whitepaper_popup',
			url: window.location.href,
			exclude_ids: submittedPopups
		},
		type: 'GET',
		success: function (respons) {
			if (respons.data.status == true) {
				const html = respons.data.html;
				$('body').append(html);
				initTeaserLogic();
			}
		}
	});

	function initTeaserLogic() {
		const $teaser = $('.whitepaper-separate-popup');
		if (!$teaser.length) return;

		const popupId = $teaser.attr('data-whitepaper-popup');

		const isFinished = () => {
			const dismissed = sessionStorage.getItem('whitepaper_separate_dismissed') === 'true';
			const submittedIds = JSON.parse(localStorage.getItem('whitepaper_submitted_ids')) || [];
			const alreadySubmitted = submittedIds.includes(popupId);
			return dismissed || alreadySubmitted;
		};

		if (isFinished()) return;

		let isTriggered = false;

		const checkBlockingElement = () => {
			const cookieBanner = document.querySelector('.cm.cm--bar.cm--bottom.cm--flip[aria-hidden="false"]');
			const eventBanner = document.querySelector('.popup-show[style*="display: block"]');
			const formPopup = document.querySelector('.overlay[style*="display: block"]');
			return cookieBanner !== null || eventBanner !== null || formPopup !== null;
		};

		const showTeaser = () => {
			if (isTriggered || isFinished() || checkBlockingElement()) return;

			$teaser.addClass('is-visible').fadeIn(300).css('display', 'flex');
			isTriggered = true;
			$(window).off('scroll.teaser');
		};

		const startTriggers = (delayMs) => {
			setTimeout(showTeaser, delayMs);

			const checkScroll = () => {
				if (isTriggered || isFinished() || checkBlockingElement()) return;

				const scrollTop = $(window).scrollTop();
				const docHeight = $(document).height();
				const winHeight = $(window).height();
				const scrollableHeight = docHeight - winHeight;

				if (scrollableHeight <= 0) return;

				const scrollPercent = (scrollTop / scrollableHeight) * 100;
				if (scrollPercent > 60) {
					showTeaser();
				}
			};

			$(window).on('scroll.teaser', checkScroll);
			checkScroll();
		};

		const observeBlockingElement = () => {
			const observer = new MutationObserver(() => {
				if (!checkBlockingElement()) {
					observer.disconnect();
					startTriggers(90000);
				}
			});

			const cookieBanner = document.querySelector('.cm.cm--bar.cm--bottom.cm--flip');
			const eventBanner = document.querySelector('.popup-show');

			if (cookieBanner) {
				observer.observe(cookieBanner, { attributes: true, childList: true, subtree: true });
			}
			if (eventBanner) {
				observer.observe(eventBanner, { attributes: true, childList: true, subtree: true });
			}
		};
		
		
		if (checkBlockingElement()) {
			observeBlockingElement();
		} else {
			startTriggers(90000);
		}
		
		$(window).on('scroll.teaser', checkScroll);
		checkScroll();

		$teaser.on('click', function () {
			let eventData = {
				event: "banner_click",
				banner_type: "lead_magnet_sidebar"
			};

			const text = $teaser.find('.whitepaper-separate-popup__title').text().trim();
			const form_name = $('.whitepaper-form-title').text().trim();
			const button = $teaser.find('.js-open-whitepaper-form').text().trim();
			const link = $teaser.find('a.popup-button');

			if (text) eventData.banner_text = text;
			if (form_name) eventData.form_name = form_name;

			if (button) {
				eventData.button_text = button;
			}

			if (link.length) {
				const url = link.attr('href') || '';
				const text_link = link.text().trim();

				if (url) {
					eventData.target_url = new URL(url, window.location.origin).href;
				}

				if (text_link) {
					eventData.button_text = text_link;
				}
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(eventData);
		});
	}
});
